<template>
  <div>
    <h1>Create Project</h1>
    <p>This is a placeholder page for creating a new project.</p>
  </div>
</template>

<script>
export default {
  name: 'ProjectCreate',
};
</script>
